
<template>
  <div class="container-xs mt-6">
    <div class="card">
      <div class="card-content">
        <h1 class="title-md">Reset Password</h1>
        <form @submit.prevent="validateBeforeSubmit('reset-paswword')" data-vv-scope="reset-paswword">

          <div class="field">
            <label class="label">{{labels.passwordLabel}}</label>
            <p class="control has-icon has-icon-right">
              <input v-model="password" v-validate="'required'" ref="password" name="password" type="password" class="input">
              <i v-show="errors.has('reset-paswword.password')" class="fa fa-warning"></i>
              <span v-show="errors.has('reset-paswword.password')" class="help is-danger">{{errors.first('reset-paswword.password')}}</span>
             </div>
          <div class="field">
                <label class="label">{{labels.repeatPasswordLabel}}</label>
               <p class="control has-icon has-icon-right">
              <input v-model="repeatPassword" v-validate="'required|confirmed:password'" name="password_confirmation" type="password" data-vv-as="password" class="input">
              <i v-show="errors.has('reset-paswword.password_confirmation')" class="fa fa-warning"></i>
              <span v-show="errors.has('reset-paswword.password_confirmation')" class="help is-danger">{{errors.first('reset-paswword.password_confirmation')}}</span>
          </div>
      
          <div class="control">
            <button type="submit" :class="{'button is-primary':true, 'is-loading disabled' : loading }"><span class="glyphicon glyphicon-off"></span> Submit</button>
          </div>
        </form>
      </div>
    </div>
  </div>

</template>
<script>
  export default {
    name: 'ResetPassword',
    data() {
      return {
        errored: false,
        labels: [],
        loading: false

      }
    },
    created() {
      this.$http
        .get('/umbraco/surface/AuthenticationSurface/ResetPassword')
        .then(response => {
          this.labels = response.data.labels;
        })
        .catch(error => {
          this.errored = true
        })
    },
    methods: {
      validateBeforeSubmit() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.loading = true;
            this.$http.post
              (
                '/umbraco/surface/AuthenticationSurface/PostResetPassword',
                {
                  email: this.$route.query.e,
                  password:this.password
                }
            ).then(response => {
                if (response.data.error)
                  this.loading = false;
                else if (response.data.redirectURL != "") {
                  this.loading = false;
                  window.location.href = response.data.redirectURL;
                }
        
              })
              .catch(error => {
                this.errored = true
              })
              
            return;
          }


        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue